'use client';

import { useEffect, useState } from 'react';
import { STATE_META, type OverallState } from './data';
import { routePath } from '@/lib/routes';

/** Footer dot on every page. SSR = neutral "Checking status…"; the real
 *  state arrives from /api/status (edge-cached 30 s). Never green by default. */
export default function StatusIndicator() {
  const [state, setState] = useState<OverallState | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetch('/api/status')
      .then((r) => (r.ok ? r.json() : null))
      .then((s) => {
        if (!cancelled && s && s.overall) setState(s.overall as OverallState);
        else if (!cancelled) setState('unknown');
      })
      .catch(() => !cancelled && setState('unknown'));
    return () => {
      cancelled = true;
    };
  }, []);

  const meta = state ? STATE_META[state] : null;
  return (
    <a href={routePath('status')} className="flex items-center gap-2 text-sm text-slate-500 transition-colors hover:text-white">
      <span aria-hidden="true" className="h-2 w-2 rounded-full" style={{ background: meta ? meta.color : 'var(--color-dim)' }} />
      {meta ? meta.label : 'Checking status…'}
    </a>
  );
}
